import styled from '@emotion/styled';

export const InteractionWrapper = styled.div`
  padding: 0 22px;
  width: 100%;

  @media (min-width: 1280px) {
    align-self: center;
    max-width: 60vw;
    padding: 0;
  }
`;
